export default __webpack_public_path__ + "static/media/user.253932d8.svg";